import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Currency, CurrencyAmount, Token } from 'sdk'
// import Button from 'app/components/Button'
import ListPanel from 'app/components/ListPanel'
import { HeadlessUiModal } from 'app/components/Modal'
import HeadlessUIModal from 'app/components/Modal/HeadlessUIModal'
import Typography from 'app/components/Typography'
import { useFarmListItemDetailsModal } from 'app/features/onsen/FarmListItemDetails'
import { setOnsenModalOpen } from 'app/features/onsen/onsenSlice'
import { useAppDispatch } from 'app/state/hooks'
import React, { FC } from 'react'
import {
  Box,
  Text,
  Button,
  Heading,
  ModalCloseButton,
} from '@chakra-ui/react'
import { CloseIcon } from '@chakra-ui/icons'

interface PoolRemoveLiquidityReviewContentProps {
  liquidityAmount?: CurrencyAmount<Token>
  parsedAmounts: (CurrencyAmount<Currency> | undefined)[]
  execute(): void
  txHash?: string
}

const PoolRemoveLiquidityReviewContent: FC<PoolRemoveLiquidityReviewContentProps> = ({
  liquidityAmount,
  parsedAmounts,
  execute,
  txHash,
}) => {
  const { i18n } = useLingui()
  const dispatch = useAppDispatch()
  const { setContent } = useFarmListItemDetailsModal()

  let confirmationModalOld = (
    <div className="flex flex-col gap-4">
      <HeadlessUIModal.Header
        header={i18n._(t`Confirm remove liquidity`)}
        onBack={() => setContent(undefined)}
        onClose={() => dispatch(setOnsenModalOpen(false))}
      />
      <Typography variant="sm">
        {i18n._(t`Output is estimated. If the price changes by more than 0.5% your transaction will revert.`)}
      </Typography>
      <HeadlessUIModal.BorderedContent className="flex flex-col gap-3 bg-dark-1000/40">
        <Typography weight={700} variant="sm" className="text-secondary">
          {i18n._(t`You are removing:`)}
        </Typography>
        <ListPanel
          items={[
            <ListPanel.CurrencyAmountItem hideCurrencyLogo={true} hideUSDC={true} amount={liquidityAmount} key={0} />,
          ]}
        />
      </HeadlessUIModal.BorderedContent>
      <HeadlessUIModal.BorderedContent className="flex flex-col gap-3 bg-dark-1000/40">
        <Typography weight={700} variant="sm" className="text-secondary">
          {i18n._(t`You'll receive (at least):`)}
        </Typography>
        <ListPanel
          items={parsedAmounts.map((parsedInputAmount, index) => (
            <ListPanel.CurrencyAmountItem amount={parsedInputAmount} key={index} />
          ))}
        />
      </HeadlessUIModal.BorderedContent>
      <Button id="btn-modal-confirm-withdrawal" color="blue" onClick={execute}>
        {i18n._(t`Confirm Withdrawal`)}
      </Button>
    </div>
  )

  let confirmationModal = (
    // <ModalContent className="add_liquidty_modal_as add_liquidty_modal_as_cnfrm_lqdt">
    <Box className="add_liquidty_modal_cntnt add_liquidty_modal_as_cnfrm_lqdt">
      <Box className="manage_txt_p_up">
        <Text>Confirm remove liquidity</Text>
        <ModalCloseButton className="close_btn_stak box_shadov_none_btn click_btn_as" style={{ marginTop: 20 }}>
          <CloseIcon />
        </ModalCloseButton>
      </Box>
      <Box className="add_liquidty_mdl_body" style={{ marginTop: 8 }}>
        <Heading as="h6" className="outpt_estmd_head">
          Output is estimated. <br />
          If the price changes by more than 0.5% your transaction will revert.
        </Heading>
        <Box className="ur_dpstng_bx_prnt">
          <Heading as="h4" className="dpsitng_h">
            You are removing:
          </Heading>
          <Box className="dpstng_bx_inn">
            <ListPanel
              items={[
                <ListPanel.CurrencyAmountItem hideCurrencyLogo={true} hideUSDC={true} amount={liquidityAmount} key={0} />,
              ]}
            />
          </Box>
        </Box>
        <Box className="white_bx_center">
          <Text>You’ll receive (at least):</Text>
          {/* <Heading as="h5">0.001556464 SLP</Heading> */}
          <ListPanel
            items={parsedAmounts.map((parsedInputAmount, index) => (
              <ListPanel.CurrencyAmountItem amount={parsedInputAmount} key={index} />
            ))}
          />
        </Box>
        {/* <Box className="text_row_as">
          <Text>Your pool share</Text>
          <Text>
            <span>8.005246%</span>
          </Text>
        </Box> */}
        <Box className="creat_pair_btn_prnt_as">
          <Button className="creat_pair_btn_as box_shadov_none_btn" onClick={execute}>Confirm Withdrawal</Button>
        </Box>
      </Box>
    </Box>
  )

  return !txHash ? (
    confirmationModal
  ) : (
    <HeadlessUiModal.SubmittedModalContent
      txHash={txHash}
      header={i18n._(t`Success!`)}
      subheader={i18n._(t`Success! Withdrawal Submitted`)}
      onDismiss={() => setContent(undefined)}
    />
  )
}

export default PoolRemoveLiquidityReviewContent
